
export default {
  title: 'Instructivo OCC Solutions - POR: Módulo de carga masiva de miembros del equipo.',
  title_body: 'Este instructivo tiene como finalidad orientar al usuario final, en la forma correcta de ' +
    'ingresar el formato de carga masiva, para prevenir errores en la carga de datos de usuarios.',
  example: 'Ejemplo:',
  use_methods: 'Forma de uso',
  description: 'Al descargar el formato de carga masiva obtendrá un archivo en formato .csv, dentro de este archivo ' +
  'podrá observar una columna, en la cual tendra la cabecera email. ' +
  'En esta columna se deben ingresar los correos electrónicos de los Colaboradores activos de su empresa que pertenezcan al equipo a evaluar',
  importDataToExcelTitle: 'Importar datos de archivo CSV a Documento Excel.',
  step1: 'Paso 1',
  step1_desc: 'Abrir Excel.',
  step2: 'Paso 2',
  step2_desc: 'Seleccionar la opción Libro en blanco',
  step3: 'Paso 3',
  step3_desc: 'Ir a la pestaña de Datos y en el apartado de Obtener datos externos, seleccionar la opción\n' +
    'Desde un archivo de texto.',
  step4: 'Paso 4',
  step4_desc: 'Seleccionar el archivo de datos CSV que desea importar. y seguidamente presione el botón\nImportar.',
  step5: 'Paso 5',
  step5_desc: 'En este punto se especifica la configuración que se usara para importar el archivo de datos.\n' +
    'Se debe indicar que los valores están Delimitados, y que se usará la codificación Unicode uft- 8,\n' +
    'como se muestra en la imagen siguiente. Esto para la correcta conversión de las palabras\nacentuadas. ' +
    'Luego se debe presionar el botón Siguiente.',
  step6: 'Paso 6',
  step6_desc: 'En este punto se debe indicar qué carácter se usara para la separación de valores.\n' +
    'Se debe indicar la coma como se muestra en la imagen siguiente.Luego se debe presionar\nel botón Finalizar.',
  step7: 'Paso 7',
  step7_desc: 'Seguidamente se le preguntará si estos datos se importarán en la hoja existente\n' +
    'o en una hoja nueva.Por defecto aparecerá seleccionada importar en la hoja existente,\n' +
    'si no es así, seleccione esta opción y presione Aceptar.',
  step8_desc: 'Finalmente los datos aparecerán separados correctamente y las palabras acentuadas se\n' +
    'importarán correctamente.'
}
